import download from 'downloadjs';

export function downloadJson(fileName: string, model: unknown) {
  // eslint-disable-next-line no-console
  if (localStorage.getItem('debug')) console.log('model', JSON.stringify(model, null, 2));
  else {
    const mimeType = 'application/json';
    const blob = new Blob([JSON.stringify(model)], { type: mimeType });
    download(blob, `${fileName || 'none'}`, mimeType);
  }
}
